import React, { useState } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import { checkPermission } from '../../../../utils_v2';
import ExceptionAcceptenceCRU from './ExceptionAcceptenceCRU';
import { AttachmentsRow } from '../../components';
import { displayDateFormatShort } from '../../../../constants';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../../shared_elements/components';

export default function ExceptionAcceptenceList({item, previewDetail, getResponseBack, contractInfo,deletecontibution}){
  const [showMore, setShowMore] = useState({});
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  return(
    <>
    <TableRow hover >
      <TableCell><div style={{width:'200px'}}>{item?.name||'--'}</div></TableCell>
      <TableCell style={{width:'400px'}}>
      {item?.description && item?.description?.length > 200 ? (
          <div style={{ width: '400px' }}>
            {showMore[item?.id] && showMore[item?.id] ? (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id); }} >
                  less
                </a>
              </span>
            ) : (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.description.substring(0, 190).replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id); }} >
                  ..more
                </a>
              </span>
            )}
          </div>
        ) : (
          <div style={{width:'200px'}}>
                {item?.description?<span dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br />') }} />:'--'}
          </div>
        )}
        </TableCell>
      {leshaBankInstance || mtInstance || avationPlcInstance ?<>
      <TableCell><div style={{width:'150px'}}>{item?.extra_fields?.eta_component||'--'}</div></TableCell>
      <TableCell><div style={{width:'100px'}}>{item?.extra_fields?.eta_amount||'--'}</div></TableCell>
      <TableCell><div style={{width:'120px'}}>{item?.extra_fields?.eta_completion_date ? moment(item?.extra_fields?.eta_completion_date).format(displayDateFormatShort) : '--'}</div></TableCell></>:null}
      <TableCell>{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell>   
      <TableCell>
        <ExceptionAcceptenceCRU getResponseBack={getResponseBack} m="V" id={item?.id} contractInfo={contractInfo}/>
        {checkPermission('contracts','exceptions_to_acceptance', 'D')?<DeleteIcon fontSize='small' color='secondary' style= {{cursor:'pointer'}} onClick={()=>deletecontibution(item?.id)}/>:null}
      </TableCell>
      </TableRow>
    </>
  )
}
